// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "/* IDs. */\n#spot-picture-file {\n    background-color: unset;\n    border: 0px;\n    border-radius: 0px;\n}\n\n#spot-picture {\n    width: 100%;\n    margin-bottom: 15px;\n    height: 300px;\n    object-fit: cover;\n}", ""]);
// Exports
module.exports = exports;
